import { FB } from "fb"

export const setFacebookAccessTokenFromLocalStorage = () => {
  if (typeof localStorage !== "undefined") {
    const fbAccessToken = localStorage.getItem("fbAccessToken")
    FB.setAccessToken(fbAccessToken)
    // console.log('>>> fbAccessToken', fbAccessToken)
  }
}
